export const updateNewTask = 'updateNewTask';
export const updateIsAddTaskClicked = 'updateIsAddTaskClicked';
export const updateTask = "updateTask";
export const updateIsEditTaskClicked = "updateIsEditTaskClicked";
export const updateTasksDataTable = "updateTasksDataTable";
export const updateIsViewTaskClicked = "updateIsViewTaskClicked";

